import checkIsVariantEnabled from './checkIsVariantEnabled';

export default function checkIsFreeCheckout({
  amount,
  productType,
  productVariants,
  formVariants,
}) {
  const hasRequiredVariantsWithPrice = productVariants?.some(variant => {
    // default true to use checkIsFreeCheckout outside of checkout state
    const variantIsVisible = formVariants
      ? checkIsVariantEnabled(variant, formVariants, productVariants)
      : true;

    const allVariantOptionsHavePrice = variant.options?.every(
      option => option.additionalChargeAmount > 0,
    );

    return variantIsVisible && variant.required && allVariantOptionsHavePrice;
  });

  if (hasRequiredVariantsWithPrice) {
    return false;
  }

  // for subscriptions we always show payment methods
  if (amount === 0 && productType !== 'subscription') {
    return true;
  }

  return false;
}
